import { render, staticRenderFns } from "./JibCrane.vue?vue&type=template&id=48353b54&scoped=true&"
import script from "./JibCrane.vue?vue&type=script&lang=js&"
export * from "./JibCrane.vue?vue&type=script&lang=js&"
import style0 from "./JibCrane.vue?vue&type=style&index=0&id=48353b54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "48353b54",
  null
  
)

export default component.exports